import { PolygraphyProductUrlType } from '../../../../../../../services/exports/Constants';

export default {
  form: {
    url_type: {
      options: {
        [PolygraphyProductUrlType.OnlineShop]: 'Onlineshop',
        [PolygraphyProductUrlType.Storefront]: 'Butiksfacade',
        [PolygraphyProductUrlType.Custom]: 'Brugerdefineret',
      },
    },
  },
  labels: {
    save_changes_to_see_preview: 'Gem ændringerne for at se forhåndsvisningen',
  },
  buttons: {
    save_and_preview: 'Gem og vis forhåndsvisning',
  },
  toasts: {
    failed_to_load_data: 'Produktet kunne ikke indlæses',
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes!',
    changes_got_saved: 'Ændringerne er gemt!',
  },
};
